import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResponseBase } from '../models/response-base';
import { Conductor, ConductorCollaborator, ConductorCollaboratorFilter } from '../models/conductors';
import { Paged } from '../models/paged';

@Injectable({
    providedIn: 'root'
})
export class ConductorService {

    private URL = environment.GATEWAY + 'conductors';

    constructor(
        private http: HttpClient
    ) { }

    getConductors(assignorGuid: string, managerGuid: string, offset: number, limit: number, cnh?: string): Observable<ResponseBase<Paged<Conductor>>> {

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);
        params = params.append('offset', offset.toString());
        params = params.append('limit', limit.toString());
        if (cnh) params = params.append('cnh', cnh);

        return this.http.get<ResponseBase<Paged<Conductor>>>(`${this.URL}/assignors/${assignorGuid}`, { params });
    }

    createConductors(assignorGuid: string, managerGuid: string, conductor: Conductor): Observable<ResponseBase<any>> {

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);

        return this.http.post<ResponseBase<any>>(`${this.URL}/assignors/${assignorGuid}`, conductor, { params });
    }

    getConductor(assignorGuid: string, managerGuid: string, id: number): Observable<ResponseBase<Conductor>> {

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);

        return this.http.get<ResponseBase<Conductor>>(`${this.URL}/${id}/assignors/${assignorGuid}`, { params });
    }

    getConductorByCollaborator(assignorGuid: string, managerGuid: string, collaboratorId: number): Observable<ResponseBase<Conductor>> {

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);

        return this.http.get<ResponseBase<Conductor>>(`${this.URL}/collaborators/${collaboratorId}/assignors/${assignorGuid}`, { params });
    }

    updateConductors(assignorGuid: string, managerGuid: string, id: number, conductor: Conductor): Observable<ResponseBase<any>> {

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);

        return this.http.put<ResponseBase<any>>(`${this.URL}/${id}/assignors/${assignorGuid}`, conductor, { params });
    }

    getCollaboratorConductors(assignorGuid: string, managerGuid: string, offset: number, limit: number, filter: ConductorCollaboratorFilter): Observable<ResponseBase<Paged<ConductorCollaborator>>> {

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);
        params = params.append('offset', (limit*offset).toString());
        params = params.append('limit', limit.toString());
        if (filter?.cnh) params = params.append('cnh', filter.cnh);
        if (filter?.name) params = params.append('name', filter.name);
        if (filter?.document) params = params.append('document', filter.document);
        if (filter?.register) params = params.append('register', filter.register);

        return this.http.get<ResponseBase<Paged<ConductorCollaborator>>>(`${this.URL}/assignors/${assignorGuid}/collaborators`, { params });
    }

    getCollaboratorConductorsByVehicle(assignorGuid: string, vehiclesGuid: string, managerGuid: string, offset: number, limit: number, filter: ConductorCollaboratorFilter): Observable<ResponseBase<Paged<ConductorCollaborator>>> {

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);
        params = params.append('offset', (limit*offset).toString());
        params = params.append('limit', limit.toString());
        if (filter?.cnh) params = params.append('cnh', filter.cnh);
        if (filter?.name) params = params.append('name', filter.name);
        if (filter?.document) params = params.append('document', filter.document);
        if (filter?.register) params = params.append('register', filter.register);

        return this.http.get<ResponseBase<Paged<ConductorCollaborator>>>(`${this.URL}/vehicles/${vehiclesGuid}/assignors/${assignorGuid}/collaborators`, { params });
    }

    linkConductorsVehicle(assignorGuid: string, vehiclesGuid: string, managerGuid: string, ids: number[]): Observable<ResponseBase<any>> {

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);

        return this.http.post<ResponseBase<any>>(`${this.URL}/vehicles/${vehiclesGuid}/assignors/${assignorGuid}/link`, ids, { params });
    }

    unlinkConductorsVehicle(assignorGuid: string, vehiclesGuid: string, managerGuid: string, ids: number[]): Observable<ResponseBase<any>> {

        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');

        let params = new HttpParams();
        params = params.append('managerGuid', managerGuid);

        const options = { headers, params, body: ids };

        return this.http.delete<ResponseBase<any>>(`${this.URL}/vehicles/${vehiclesGuid}/assignors/${assignorGuid}/link`, options);
    }

    changeConductorPassword(conductorGuid: string): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL}/password/${conductorGuid}`, null);
    }

}
